import styles from './IterationListItem.module.css';

import classNames from 'classnames';
import { ITERATION_STATUS } from 'consts/project.const';
import { useListDrawerContext } from 'widgets/ListNavigationDrawer/ListDrawerProvider';

const IterationListItem = ({ item, cellClassName = undefined }) => {
  const { selected, selectedKey, setSelected } = useListDrawerContext();

  const StatusIteration = () => {
    return (
      <div className={styles.statusPointContainer}>
        <div
          className={classNames(styles.statusPoint, {
            [styles.not_started]: item.status === ITERATION_STATUS.NOT_STARTED,
            [styles.in_progress]: item.status === ITERATION_STATUS.IN_PROGRESS,
            [styles.completed]: item.status === ITERATION_STATUS.COMPLETED,
            [styles.force_completed]: item.status === ITERATION_STATUS.FORCECOMPLETED,
          })}
        />
      </div>
    );
  };

  return (
    <tr
      className={classNames(styles.rowItem, { [styles.active]: item[selectedKey] === selected })}
      onClick={() => setSelected(item[selectedKey])}
    >
      <td colSpan={2} className={classNames(styles.item, styles.defaultItem, cellClassName)}>
        <div className={styles.itemName}>
          <StatusIteration />
          {item.name}
        </div>
        <div
          className={classNames({ [styles.underline]: item.is_editable || item.is_deletable })}
        />
      </td>
    </tr>
  );
};

export default IterationListItem;
